import React from 'react';
import "../Figure.css"


function Figure5() {
  return (
    <div>
        <table class="equal-width-table">
          <thead>
            <tr>
              <th></th>
              <th> SpaC </th>
              <th> EC20 (negative control) </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td> <b> Fluorescence </b></td>
              <td> 1 300 </td>
              <td> 4 400 </td>
            </tr>
          </tbody>
        </table>
    </div>
  );
}

export default Figure5;